module.exports = __webpack_public_path__ + "img/tank.e011e668.svg";